export enum DataMarketplaceCodes {
  LIVERAMP = 'LIVERAMP',
}
